const projectData = [
    {
        id: 1,
        text: 'Analysis Malware Trojan',
        subtext: 'Malware analysis with the type of trojan virus from a particular website',
        users: [require('@/assets/images/users/avatar-2.jpg'), require('@/assets/images/users/avatar-1.jpg')],
        status: 'Valid',
        threat_name: 'Trojan:Script',
        tags: [],
        md5: '5f358afee76f2a74b1a3443c6012b27b',
        date: '10 Des, 22',
        comment: 2
    },
    {
        id: 2,
        text: 'New Malware Threat',
        subtext: 'A new trojan virus that attacks the target by deleting all data in the form of a .troj file',
        users: [require('@/assets/images/users/avatar-3.jpg')],
        status: 'Pending',
        threat_name: 'Trojan:Downloader/Idm.Win32',
        tags: ['Trojan', 'idm', 'windows'],
        md5: '4ac8d962c6072b77f157c5d6459b887',
        date: '11 Des, 22',
        comment: 5
    },
    {
        id: 3,
        text: 'Ransom SyncAck',
        subtext: 'Ransomware virus analysis with new types',
        users: [require('@/assets/images/users/avatar-5.jpg'), 'A', require('@/assets/images/users/avatar-4.jpg')],
        status: 'Not Valid',
        threat_name: 'Ransom.SyncAck',
        tags: ['Ransom', 'SyncAck'],
        md5: '0dcd973b0b0a373e78f6183b81cf9d68',
        date: '11 Des, 22',
        comment: 5
    },
    {
        id: 4,
        text: 'Redesign - Landing page',
        subtext: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 2260s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        users: [require('@/assets/images/users/avatar-6.jpg'), 'D'],
        status: 'Valid',
        threat_name: 'Exploit:PDF/che-2000-5090',
        tags: [],
        md5: '5f358afee76f2a78kal9aa9923as2b27b',
        date: '14 Des, 19',
        comment: 11
    },
    {
        id: 5,
        text: 'Skote Dashboard UI',
        subtext: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        users: [require('@/assets/images/users/avatar-7.jpg'), require('@/assets/images/users/avatar-8.jpg')],
        status: 'Valid',
        threat_name: 'Exploit:PDF/che-2000-5090',
        tags: [],
        md5: '5f358afee76f2a74b1a3443c6012b27b',
        date: '13 Des, 22',
        comment: 8
    },
    {
        id: 6,
        text: 'Blog Template UI',
        subtext: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        users: [require('@/assets/images/users/avatar-6.jpg'), 'D'],
        status: 'Pending',
        threat_name: 'Exploit:PDF/che-2000-5090',
        tags: [],
        md5: '5f358afee76f2a74b1a3443c6012b27b',
        date: '14 Des, 22',
        comment: 4
    },
    {
        id: 7,
        text: 'Multipurpose Landing',
        subtext: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        users: [require('@/assets/images/users/avatar-3.jpg')],
        status: 'Not Valid',
        threat_name: 'Exploit:PDF/che-2000-5090',
        tags: [],
        md5: '5f358afee76f2a74b1a3443c6012b27b',
        date: '15 Des, 22',
        comment: 10
    },
    {
        id: 8,
        text: 'App Landing UI',
        subtext: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        users: [require('@/assets/images/users/avatar-4.jpg'), 'D'],
        status: 'Valid',
        threat_name: 'Exploit:PDF/che-2000-5090',
        tags: [],
        md5: '5f358afee76f2a74b1a3443c6012b27b',
        date: '11 Des, 22',
        comment: 4
    },
    {
        id: 9,
        text: 'New admin Design',
        subtext: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        users: [require('@/assets/images/users/avatar-5.jpg')],
        status: 'Valid',
        threat_name: 'Exploit:PDF/che-2000-5090',
        tags: [],
        md5: '5f358afee76f2a74b1a3443c6012b27b',
        date: '12 Des, 22',
        comment: 1
    },
];

export { projectData };